export default __webpack_public_path__ + "static/media/dna.9780f940.webp";